<template>
  <div>
    <Button type="primary" @click="modal = true" v-hasPermission="['permissionsConfigurationManagement:accountGroup:add_group']">{{ $t('RIAccountGroupManagement.addRIAccountGroup') }}</Button>
    <Modal v-model="modal" :title="$t('RIAccountGroupManagement.addRIAccountGroup')" :loading="loading" @on-ok="accountGroupSubmit('accountGroupForm')"
           @on-cancel="accountGroupReset('accountGroupForm')" :mask-closable="false" :okText="$t('alarms.common.add')" :cancelText="$t('alarms.common.cancel')">
      <Form ref="accountGroupForm" :model="accountGroupForm" :label-width="100" :rules="ruleValidate">
        <!-- 公司 -->
        <div v-if="company == 1">
            <FormItem :label="$t('permission_configuration_management.account.company')" prop="companyId">
                <Select v-model="companyId" style="width:300px;" :placeholder="$t('configuration_management.common.pleaseSelect')">
                    <Option :value="item.id" v-for="(item,index) in companyList" v-bind:key="index">{{item.name}}
                    </Option>
                </Select>
            </FormItem>
        </div>
        <!-- 地区 -->
        <FormItem :label="$t('permission_configuration_management.account.area')" prop="areaType">
            <Select v-model="accountGroupForm.areaType" style="width:300px;"
                @on-change="changeAccount(accountGroupForm.areaType)" :transfer="true" :placeholder="$t('configuration_management.common.pleaseSelect')">
                <Option :value="item.id" v-for="(item,index) in areaTypeList" v-bind:key="index">{{item.name}}</Option>
            </Select>
        </FormItem>
        <!-- 区域 -->
        <FormItem :label="$t('permission_configuration_management.account.region')" prop="region">
            <Select v-model="accountGroupForm.region" style="width:300px;" :transfer="true"  :placeholder="$t('configuration_management.common.pleaseSelect')">
                <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
            </Select>
        </FormItem>
        <!-- 财务账户组名称 -->
        <FormItem :label="$t('RIAccountGroupManagement.RIAccountGroupName')" prop="name">
          <Input v-model="accountGroupForm.name" placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>

        <!-- 备注 -->
        <FormItem :label="$t('RIAccountGroupManagement.comment')" prop="remark">
          <Input v-model="accountGroupForm.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"
                 placeholder="Enter something..." style="width:300px;"></Input>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import TableAccountGroup from '../account_group/TableAccountGroup'
    var tableAccountGroup = TableAccountGroup;
    export default {
        data() {
            // 名字是否重复
            var validNameRepeatedCheck = (rule, value, callback) => {
                var self = this;
                self.$api.accountGroup.checkAccountGroupName({
                    "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                    "accountGroupName": this.accountGroupForm.name
                })
                .then(res => {
                    if (res.status == 200) {
                        callback();
                    }
                })
                .catch(err => {
                    if (err.status == 400) {
                        callback(new Error('财务账户组名称不能重复!'));
                    }
                })
            };
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                show: false,
                accountGroupForm: {
                    name: '',
                    remark: '',
                    areaType: '',
                    region: ''
                },
                areaTypeList: [{
                    id:1,
                    name: this.$t('RIAccountGroupManagement.China')
                },{
                    id:2,
                    name: this.$t('RIAccountGroupManagement.Overseas')
                }],
                regionList: [],
                loading: true,
                modal: false,
                ruleValidate: {
                    name: [
                        {required: true, message: this.$t('RIAccountGroupManagement.accountGroupNameNotEmpty'), trigger: 'blur'},
                        {type: 'string', message: this.$t('RIAccountGroupManagement.accountGroupNameValidateMsg'), pattern: '^.{4,20}$', trigger: 'blur'},
                        {validator: validNameRepeatedCheck, trigger: 'blur'}
                    ],
                    areaType: [
                        {required: true, message: this.$t('RIAccountGroupManagement.pleaseSelectArea'), trigger: 'change', type: 'number'}
                    ],
                    region: [
                        {required: true, message: this.$t('RIAccountGroupManagement.pleaseSelectRegion'), trigger: 'change'}
                    ]
                }
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
             },
            // 切换地区
            changeAccount: function () {
                if (this.accountGroupForm.areaType == "" || this.accountGroupForm.areaType == null) {
                    return;
                }
                this.accountGroupForm.region = '';
                this.$api.accountGroup.getRegionByAreaType("areaType", this.accountGroupForm.areaType)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            // 确定
            accountGroupSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if (valid) {
                        var updateGroup = {
                            "companyId": (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId,
                            "accountGroupName": this.accountGroupForm.name,
                            "remark": this.accountGroupForm.remark,
                            "areaType": this.accountGroupForm.areaType,
                            "region": this.accountGroupForm.region
                        };

                        this.$api.accountGroup.createAccountGroup(updateGroup)
                            .then(res => {
                                this.data = res.data;
                                setTimeout(() => {
                                    tableAccountGroup.methods.showAll();
                                    this.$refs[name].resetFields();
                                    this.loading = false;
                                    this.$nextTick(() => {
                                        this.loading = true;
                                    });
                                    this.$Message.success('添加成功');
                                    this.modal = false;
                                }, 1000);
                            })
                    } else {
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('添加失败');
                    }
                });
            },
            // 取消
            accountGroupReset: function (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/AddAccountGroup.vue